const ViewRightIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11L11 16H0V5L5 0H16V11ZM15 10H12V11H14.2929L11 14.2929V5.70711L15 1.70711V10ZM14.2929 1L10.2929 5H1.70711L5 1.70711V4H6V1H14.2929ZM6 10H9V11H5.70711L1.70711 15H10V6H1V14.2929L5 10.2929V7H6V10Z"
        fill="#424242"
      />
      <path d="M15.5 10.5L11 14.5V5.5L15.5 1V10.5Z" fill="#424242" />
    </svg>
  );
};

export default ViewRightIcon;
